import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  generateSolutionStart,
  resetGenerateSolution,
} from "../../redux/questions/reducer";
import {
  selectIsGenerateSolution,
  selectGenerateSolution,
} from "../../redux/questions/selectors";

const useGenerateSolution = () => {
  const dispatch = useDispatch();
  const isGenerating = useSelector(selectIsGenerateSolution);
  const generatedSolution = useSelector(selectGenerateSolution);

  const generateSolution = useCallback(
    (data) => {
      dispatch(generateSolutionStart(data));
    },
    [dispatch]
  );

  const resetGeneratedSolution = () => {
    dispatch(resetGenerateSolution());
  };

  return {
    isGenerating,
    generateSolution,
    resetGeneratedSolution,
    generatedSolution,
  };
};

export default useGenerateSolution;
